import React from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { getGalleryProject } from '@modules/get-data';
import { GalleryProjectPage } from '@sections/Gallery-Project';
import { GALLERY_PATH, PROCESSING_ITEMS } from "@constants";
import { getErrorContent, redirect } from "@libs";
import { ErrorStub } from "@components/Error-Stub";

const GalleryProject = ({ tags, projects, project }) => (
    <GalleryProjectPage projects={projects} tags={tags} project={project} />
);

GalleryProject.getLayout = (page, { project, errorCode }) => {
  const { translations } = page.props;

  if (errorCode || !project) {
    const error = getErrorContent({ code: errorCode });

    return (
        <ErrorLayout title={translations.t('site.galleryProjects.title')}>
          <ErrorStub error={error} />
        </ErrorLayout>
    );
  }

  return (
      <MainLayout
          title={`${project.title} - ${translations.t('site.galleryProjects.title')}`}
          processing={PROCESSING_ITEMS.GET_BLOG}
          description={project.description}
          keywords={project.title}>
        {page}
      </MainLayout>
  )
};

GalleryProject.getInitialProps = async ({ store, query, res }) => {
  const { dispatch, getState } = store;
  const data = await dispatch(getGalleryProject(query));
  const { errors, settings: { locale }} = getState();
  const error = errors[PROCESSING_ITEMS.GET_GALLERY_PROJECTS];

  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { ...data, errorCode: error.code };
  }

  if (!data.project) {
    redirect(`/${locale}/${GALLERY_PATH}/`, {locale}, 301, res);
  }

  return data;
};

export default withUser(GalleryProject);
